import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import LogIn from "./pages/login/login";
import DepositHistory from "./pages/deposit-history/deposit-history";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Публичные маршруты */}
          <Route path="/" index element={<LogIn />} />
          {/* <Route path="/deposit-history" index element={<DepositHistory />} /> */}

          {/* Защищенные маршруты */}
          <Route
            path="/deposit-history"
            element={
              <ProtectedRoute>
                <DepositHistory />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
